import styled, { ThemeProvider } from 'styled-components'
import {darkTheme, lightTheme} from './utils/Themes'
import NavigationBar from './components/NavigationBar';
import { BrowserRouter } from 'react-router-dom';
import AboutMe from './components/AboutMe';
import Skills from './components/skills';
import Experience from './components/experience';
import StarCanvas from "./components/canvas/Stars";
import Projects from './components/projects';
import Footer from './components/footer';
import { Analytics } from "@vercel/analytics/react"
import RiveWidgets from './components/RiveWidgets';
import useRiveTriggers from './hooks/useRiveTriggers';


const Body = styled.div`
  background-color: ${({theme}) => theme.bg};
  color: ${({theme}) => theme.text_primary};
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  position: relative;
`


function App() {
  const { ControlPanel, LightDarkMode, isLightMode, isPaused, angleOfRotation } = useRiveTriggers();

  const selectedTheme = isLightMode.value ? lightTheme : darkTheme;



  return (
    <ThemeProvider theme={selectedTheme}>
      <BrowserRouter>
      <NavigationBar/>
      <Body>
      <StarCanvas isPaused={isPaused.value} angleOfRotation={angleOfRotation.value} />
        <AboutMe/>
        <Experience/>
        <RiveWidgets ControlPanelProp={ControlPanel} LightDarkModeProp={LightDarkMode} />
        <Skills/>
        <Projects/>
        <Footer/> 
        <Analytics/>
      </Body>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
